import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getFromLocale, getSiteInfo } from "@/utils";

const { lang, curr, siteName } = getSiteInfo() ??{}


export const projectApi = createApi({
  reducerPath: "projectApis",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.API_URL}/api`,
    prepareHeaders: (headers) => {
      headers.set("Authorization", `Bearer ${getFromLocale()}`);
      headers.set("Accept", "application/json");
      headers.set("Currency", `${curr}`);
      headers.set("Language", `${lang}`);
      headers.set("Referrer", siteName);
      return headers;
    },
  }),
  tagTypes: ["project", "serviceTypes", "projectMut"],
  endpoints: (builder) => ({
    getProjectList: builder.query({
      query: ({ page }) => `/project?page=${page}`,
      providesTags: ["project"],
    }),
    getServiceTypes: builder.query({
      query: () => `/service-types`,
      providesTags: ["serviceTypes"],
    }),
    haveProject: builder.mutation({
      query: (formData) => ({
        url: "/project",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["projectMut"],
    }),
  }),
});

export const {
  useLazyGetProjectListQuery,
  useGetServiceTypesQuery,
  useHaveProjectMutation,
} = projectApi;
